<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
</script>

<template>
  <div class="flex justify-center p-5">
    <SVG
      icon="fas-spinner-third"
      height="2rem"
      width="2rem"
      class="text-neutral700 animate-spin"
    />
  </div>
</template>
